import en from './locales/en';

// const en = {};

const messages = {
    en
};

export default messages;
